import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { Form, Input, Radio } from 'antd';
import LoadableButton from '../../../../components/buttons/LoadableButton';
import { GetCurrentCurrencyRateApi } from '../../../../api/request/wallet/cashdeposit';
import { GetPaymentGatewayApi } from '../../../../api/request/wallet/deposit';
import CashDeposit from './components/CashDeposit';
import RMDT_Token from './components/RMDT_Token';
import UpiDeposit from './components/UpiDeposit';
import UsdtTrc20 from './components/UsdtTrc20';
import Stripe from './components/Stripe';
import CreditDebitCard from './components/CreditDebitCard';
import ZaroPay from './components/ZaroPay';
import UniPayment from './components/UniPayment';
import UPS from './components/UPS';
import PaymentMethodInfo from './components/PaymentMethodInfo';
import { GetMT5AccountsApi } from '../../../../api/request/transfer';
import DepositRequest from './DepositRequest';

const Deposit2 = () => {
    const [form] = Form.useForm();
    const [paymentGateways, setPaymentGateways] = useState([]);
    const [currencyRate, setCurrencyRate] = useState(null);
    const [accounts, setAccounts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [amount, setAmount] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState(null);
    const [step, setStep] = useState(1);
    const [isRefresh, setIsRefresh] = useState(false);
    const [isCashDeposit, setIsCashDeposit] = useState(false)
    const [isRMDTToken, setIsRMDTToken] = useState(false)

    const getPaymentGateway = async () => {
        setIsLoading(true);
        try {
            const { data } = await GetPaymentGatewayApi(1);
            if (data?.success) setPaymentGateways(data?.data);
        } catch (error) {
            if (error?.response?.data?.error?.message)
                toast.error(error?.response?.data?.error?.message);
        } finally {
            setIsLoading(false);
        }
    }

    const getCurrentCurrencyRate = async () => {
        try {
            const { data } = await GetCurrentCurrencyRateApi();
            if (data?.success) setCurrencyRate(data?.data);
        } catch (error) {
        }
    }

    const getAccounts = async () => {
        setIsLoading(true);
        try {
            const { data } = await GetMT5AccountsApi(true);
            if (data?.success) {
                setAccounts(data?.data?.filter((account) => account?.isLive));
            }
        } catch (error) {
            if (error?.response?.data?.error?.message)
                toast.error(error?.response?.data?.error?.message);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getPaymentGateway();
        getCurrentCurrencyRate();
        getAccounts();
    }, []);

    const validateAmount = (_, value) => {
        if (!value) {
            setStep(1);
            return Promise.reject(new Error('Please enter amount.'));
        }

        if (Number(value) <= 0) {
            setStep(1);
            return Promise.reject(new Error('Please enter a valid amount.'));
        }

        if (amount < paymentMethod?.minAmount) {
            setStep(1);
            return Promise.reject(new Error(`Amount must be at least $${paymentMethod?.minAmount}.`));
        }

        if (amount > paymentMethod?.maxAmount) {
            setStep(1);
            return Promise.reject(new Error(`Amount cannot exceed $${paymentMethod?.maxAmount}.`));
        }

        return Promise.resolve();
    };

    const handleSubmit = (values) => {
        if ((values?.amount || values?.inrAmount || values?.rmdtAmount) && values?.paymentMethod) setStep(2);
    }

    const resetAll = () => {
        form.resetFields();
        setAmount(0);
        setPaymentMethod(null);
        setStep(1);
        setIsRefresh(true);
    }

    const renderStep = () => {
        switch (paymentMethod?.name) {
            case "CashDeposit":
                return <CashDeposit amount={amount} resetAll={resetAll} />;
            case "RMDT Token":
                return <RMDT_Token amount={amount} paymentMethod={paymentMethod} resetAll={resetAll} />;
            case "UPI":
                return <UpiDeposit amount={amount} paymentMethod={paymentMethod} resetAll={resetAll} />;
            case "USDT-TRC20":
                return <UsdtTrc20 amount={amount} paymentMethod={paymentMethod} resetAll={resetAll} />;
            case "Stripe":
                return <Stripe amount={amount} paymentMethod={paymentMethod} accounts={accounts} resetAll={resetAll} />;
            case "Network":
                return <CreditDebitCard amount={amount} paymentMethod={paymentMethod} accounts={accounts} resetAll={resetAll} />;
            case "ZaroPay":
                return <ZaroPay amount={amount} paymentMethod={paymentMethod} accounts={accounts} resetAll={resetAll} />;
            case "Unipayment":
                return <UniPayment amount={amount} paymentMethod={paymentMethod} accounts={accounts} resetAll={resetAll} />;
            case "UPS":
                return <UPS amount={amount} paymentMethod={paymentMethod} resetAll={resetAll} />;
            default:
                return null;
        }
    }

    useEffect(() => {
        if (paymentMethod?.name === "CashDeposit") {
            form.setFieldValue('inrAmount', amount * currencyRate?.targetCurrencyDepositRate)
            setIsCashDeposit(true)
            setIsRMDTToken(false)
        } else if (paymentMethod?.name === "RMDT Token") {
            form.setFieldValue('rmdtAmount', amount * paymentMethod?.currencyRate)
            setIsRMDTToken(true)
            setIsCashDeposit(false)
        } else {
            setIsCashDeposit(false)
            setIsRMDTToken(false)
        }
    }, [paymentMethod?.name])


    return (
        <div className='space-y-5'>
            <div className='grid grid-cols-8 gap-5'>
                <div className='col-span-8 xl:col-span-3 border-2 border-light rounded-lg p-5'>
                    <Form form={form} layout='vertical' className='space-y-5' onFinish={handleSubmit}>
                        {
                            isCashDeposit ?
                                <>
                                    <Form.Item
                                        name='inrAmount'
                                        label={<span className="text-lg text-gray-500 font-medium">Amount In INR <span className='text-lg primary font-semibold'>(${currencyRate?.baseCurrencyRate} = {currencyRate?.targetCurrencyDepositRate} {currencyRate?.targetCurrency})</span></span>}
                                        rules={[{ validator: validateAmount }]}
                                    >
                                        <Input type='number' prefix="₹" addonAfter={`$ ${Number(amount)?.toFixed(2)}`} placeholder="Amount in INR" size='large' onChange={(e) => setAmount(e?.target?.value / currencyRate?.targetCurrencyDepositRate)} />
                                    </Form.Item>
                                </>
                                : isRMDTToken ?
                                <>
                                    <Form.Item
                                        name='rmdtAmount'
                                        label={<span className="text-lg text-gray-500 font-medium">Amount In RMDT <span className='text-lg primary font-semibold'>($1 = {paymentMethod?.currencyRate} RMDT)</span></span>}
                                        rules={[{ validator: validateAmount }]}
                                    >
                                        <Input type='number' prefix={<p className='text-xs me-2'>RMDT</p>} addonAfter={`$ ${Number(amount)?.toFixed(2)}`} placeholder="Amount in RMDT" size='large' onChange={(e) => setAmount(e?.target?.value / paymentMethod?.currencyRate)} />
                                    </Form.Item>
                                </>
                                :
                                <Form.Item
                                    name='amount'
                                    label={<span className="text-lg text-gray-500 font-medium">Amount In USD <span className='text-lg primary font-semibold'>(${currencyRate?.baseCurrencyRate} = {currencyRate?.targetCurrencyDepositRate} {currencyRate?.targetCurrency})</span></span>}
                                    rules={[{ validator: validateAmount }]}
                                >
                                    <Input type='number' placeholder="Amount in USD" size='large' onChange={(e) => setAmount(e?.target?.value)} />
                                </Form.Item>
                        }

                        <Form.Item
                            name="paymentMethod"
                            label={<span className="text-lg text-gray-500 font-medium">Select Payment Method</span>}
                            rules={[{ required: true, message: 'Please select a payment method.' }]}
                            required={false}
                        >
                            <Radio.Group className="w-full grid grid-cols-1 md:grid-cols-2 gap-3">
                                {paymentGateways?.map((item, index) => (
                                    <Radio
                                        key={index}
                                        value={item?.id}
                                        className={`flex items-center gap-1 border-2 rounded-lg p-3 m-0 ${paymentMethod?.id === item?.id ? 'border-primary' : 'border-light'}`}
                                        onChange={() => setPaymentMethod(item)}
                                    >
                                        <div className='flex items-center gap-3'>
                                            <img
                                                src={item?.paymentLogoUrl}
                                                alt="Icon"
                                                className="h-[35px] w-[35px] object-contain"
                                            />
                                            <span className='break-all'>{item?.name}</span>
                                        </div>
                                    </Radio>
                                ))}
                            </Radio.Group>
                        </Form.Item>

                        <div className='flex items-center justify-end'>
                            <LoadableButton
                                className='bg-primary text-sm text-white font-semibold rounded-lg px-4 py-2 uppercase themeHover duration-500'
                                type="submit"
                                lable='Next'
                            />
                        </div>
                    </Form>
                </div>

                <div className='col-span-8 xl:col-span-5 border-2 border-light rounded-lg p-5'>
                    {step === 2 ? (
                        <div className='flex flex-col gap-10'>
                            <PaymentMethodInfo paymentMethod={paymentMethod} />

                            {renderStep()}
                        </div>
                    ) : (
                        <div className='h-full flex items-center justify-center'>
                            <p className='text-lg text-gray-500'>Please select a payment method.</p>
                        </div>
                    )}
                </div>
            </div>

            <DepositRequest isRefresh={isRefresh} setIsRefresh={setIsRefresh} />
        </div>
    )
}

export default Deposit2